import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useSession } from "next-auth/react";
import { signIn } from "next-auth/react";
import { deviceDetect } from "react-device-detect";
import publicIp from "public-ip";
import { useFormik } from "formik";
import { useRouter } from "next/router";
import bcrypt from "bcryptjs";

//assets
import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import AppLogo from "../../../public/assets/img/app-logo.png";

//components
import { ClientSignUpSchema } from "@/kyna/lib/validations/UserSchema";
import InputForm from "@/kyna/forms/InputForm";
import Spinner from "@/kyna/ui/preloader/Spinner";
import KNModal from "@/kyna/ui/modal/KNModal";
import KNModalBody from "@/kyna/ui/modal/KNModalSchemaErrors";

//helpers
import { KTPost } from "../../lib/db";

const device = deviceDetect();

const RegisterBody = () => {
  const [isLoading, setLoading] = useState(false);
  const [signupFormMessage, setsignupFormMessage] = useState(null);
  const [signupFormMessageType, setsignupFormMessageType] = useState(null);
  const { data: session, status } = useSession();
  const [SchemaErrors, setSchemaErrors] = useState({});
  const [showPassword, setShowPassword] = useState("password");

  // PAGE MODAL
  let [modalIconType, setModalIcon] = useState("info");
  let [modalTitle, setModalTitle] = useState("");
  let [modalDescription, setModalDescription] = useState("");
  let [modalBody, setModalBody] = useState("");
  let [isModalOpen, setModalOpen] = useState(false);
  const router = useRouter();

  const submitHandler = async (values) => {
    setLoading(true);
    setsignupFormMessage(null);
    setsignupFormMessageType(null);

    console.log("Submit");
    console.log("Submit values", values);

    // return;

    const result = await saveUserInfo(values);

    setLoading(false);
    console.log("Register post result", result);

    if (result.status != 200) {
      console.log("error");
      console.log(result.error);
      // alert("");
      setsignupFormMessage("There's an error occur, please try again.");
      setsignupFormMessageType("text-red-400");
      return;
    }

    if (result.status == 200 && result.data.code == 422) {
      console.log("error");
      console.log(result);

      setSchemaErrors(result.data.schemaErrors);

      setModalOpen(true);
      setModalIcon("error");
      setModalTitle("Form validation error");
      setsignupFormMessage("");
      return;
    }

    // return
    // SUCCESS FULL REGISTRATION

    setsignupFormMessage("Account has been saved!");
    setsignupFormMessageType("text-green-400");

    // return;
    setLoading(true);

    const signInResult = await signIn("credentials", {
      redirect: false,
      username: values.email,
      password: values.password,
    });

    console.log("signInResult", signInResult);

    setLoading(false);

    if (signInResult.error) {
      console.log("error loginForm");
      console.log(signInResult.error);
      // alert("");
      setsignupFormMessage("Invalid username and password.");
      setsignupFormMessageType("text-red-400");
    } else {
      console.log("signInResult", signInResult);
      console.log("session", session);

      // SAVE USER ACTIVITY
      // SAVE USER DEVICE
      // const userActivityResponse = ;

      // console.log("userActivityResponse", userActivityResponse)

      setLoading(true);

      const UserRegistrationQueries = await Promise.all([
        await saveUserActivity(result.data.user),
        await saveUserDevice(result.data.user),
      ]);

      console.log("UserRegistrationQueries", UserRegistrationQueries);

      if (UserRegistrationQueries) {
        setLoading(false);
        setsignupFormMessage("Auto login");
        setsignupFormMessageType("text-green-400");

        // return;

        if (signInResult.ok) {
          // window.location = '/app/dashboard'
          router.push("/app/account/onboarding");
        }
      }
    }
  };

  const saveUserInfo = async (values) => {
    const hashedPassword = await bcrypt.hash(values.password, 10);

    return await KTPost("/api/users/register", {
      user: {
        account_no: "",
        username: values.email,
        password: hashedPassword,
        status: "Active",
        user_role_id: 1, // TODO, ADD TO THE GLOBAL CONFIG FOR PUBLIC REGISTRATION
      },

      person: {
        first_name: values.first_name,
        last_name: values.last_name,
        contact_no: values.contact_no,
        email: values.email,
      },
    });
  };

  const saveUserActivity = async (userResponse) => {
    return await KTPost("/api/users/activity", {
      user_id: userResponse.id,
      user_name: userResponse.username,
      title: "Account Registration",
      body: "",
      table_name: "User",
      type: "Public Account",
      reference_id: userResponse.id,
      status: "Active",
    });
  };

  const saveUserDevice = async (userResponse) => {
    try {
      console.log("deviceDetect", device);
      const IP_Address = await publicIp.v4();
      console.log("MyIP:", IP_Address);

      if (device) {
        return await KTPost("/api/users/device", {
          browser_full_version: device.browserFullVersion,
          browser_major_version: device.browserMajorVersion,
          browser_name: device.browserName,
          engine_name: device.engineName,
          engine_version: device.engineVersion,
          is_browser: device.isBrowser,
          os_name: device.osName,
          os_version: device.osVersion,
          user_agent: device.userAgent,
          ip_address: IP_Address,
          user_id: userResponse.id,
        });
      }
    } catch (error) {
      console.log("device error", error);
      // return error;
    }
  };

  // useEffect(() => {});

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      contact_no: "",
      reference_code: "",
      email: "",
      password: "",
      acknowledge: "",
    },
    validationSchema: ClientSignUpSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));

      submitHandler(values);
    },
  });

  return (
    <div className="">
      <header className="relative md:relative pb-20 lg:fixed xl:fixed top-0 bottom-0 bg-gray-800 landing-header">
        <section className="p-10 max-w-xs mx-auto landing-logo relative z-30">
          <Link href="/">
            <a className="block w-32">
              <Image src={AppLogo} alt="PMHA" />
            </a>
          </Link>
        </section>
        <div className="absolute left-0 right-0 bottom-0 z-30 p-10 hidden lg:block">
          <div className="text-white text-sm text-center">
            <p className="uppercase px-2 text-sm text-center lg:text-left lg:inline tracking-wider">PMHA {new Date().getFullYear()}. All Rights Reserved. Powered by <Link href="https://kynatech.ph/"><a target="_blank">kynatech.ph</a></Link></p>
          </div>
        </div>
        <div className="absolute inset-0 gradient-bg z-20 bg-gradient-to-b from-white to-blue opacity-80"></div>
        <div className="absolute inset-0 bg-1 z-10"></div>
      </header>
      <section className="landing-right-container">
        <div className="container hidden lg:block">
          <div className="flex items-start justify-center md:justify-end">
            <div className="p-12 md:pb-0 md:pr-0 lg:pr-12 sm:text-center">
              <span>
                Already a member?{" "}
                <Link href="/account/login">
                  <a>Login</a>
                </Link>
              </span>
            </div>
          </div>
        </div>
        <div className="container max-w-screen-sm p-0 lg:px-16 mx-auto">
          <div className="lg:px-5 px-5 sm:p-10 pt-14 sm:pt-0 sm:px-10 lg:p-0 mx-auto sm:mt-16 md:mt-20 lg:mt-20">
            <h1 className="header-1 mb-10">Register to PMHA System </h1>
            <section>
              <div className="or-div my-5 relative text-center hidden">
                <span className="line-div"></span>
                <span className="or-text">Or</span>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div className="flex-none md:flex justify-between gap-5">
                  <InputForm
                    type="text"
                    id="first_name"
                    name="first_name"
                    placeholder="First Name*"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                  />
                  <InputForm
                    type="text"
                    id="last_name"
                    name="last_name"
                    placeholder="Last Name*"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                  />
                </div>

                <div className="flex-none md:flex justify-between gap-5">
                  <InputForm
                    type="text"
                    id="contact_no"
                    name="contact_no"
                    placeholder="Contact No.*"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                    // className={"pl-7"}
                  />
                  <InputForm
                    type="text"
                    id="reference_code"
                    name="reference_code"
                    placeholder="Reference Code*"
                    withFormik={true}
                    formik={formik}
                    parentClassName="w-full"
                  />
                </div>

                <InputForm
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email Address*"
                  withFormik={true}
                  formik={formik}
                  onBlur={(e) => {
                    // console.log("email", e.target.value)
                    formik.setFieldValue("username", e.target.value);
                    delete SchemaErrors.username;
                    setSchemaErrors(SchemaErrors);
                  }}
                  helpBlockClass={"text-red-400"}
                  helpBlockText={
                    SchemaErrors?.username && SchemaErrors.username
                  }
                />
                <div className={`form-control !p-0 w-full  grid grid-cols-12 items-center gap-x-2`}>
                  <input
                    className={`form-control !p-0 !pl-4 col-span-11`}
                    type={showPassword}
                    id="password"
                    placeholder="Password*"
                    onChange={(e) => {
                      formik.setFieldValue("password", e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    name="password"
                  />
                  {showPassword === "password" ? (
                    <EyeIcon onClick={() => {setShowPassword("text")}} className="col-span-1 h-5 w-5 text-blue-500 cursor-pointer" />
                  ) : (
                    <EyeOffIcon onClick={() => {setShowPassword("password")}} className="col-span-1 h-5 w-5 text-blue-500 cursor-pointer" />
                  )}
                </div>
                {
                    <div className="help-block text-red-400 text-xs mt-2">
                      {formik.touched.password &&
                        formik.errors.password && (
                          <div>{formik.errors.password}</div>
                        )}
                    </div>
                  }


                {signupFormMessage != "" ? (
                  <div className={`mt-1 text-sm mb-2 ${signupFormMessageType}`}>
                    {signupFormMessage}
                  </div>
                ) : null}

                {/* {
                                    getErrorBody(SchemaErrors)
                                } */}

                {/* <pre>
                                    <div>{SchemaErrors.length}</div>
                                    {JSON.stringify(SchemaErrors, null, 1)}
                                </pre> */}

                {/* <div className="flex-none md:flex justify-between items-center">
                                    <div className="form-group">
                                        <Link href="#"><a className='text-gray-800'>Forgot password / username</a></Link>
                                    </div>
                                    <div className="form-group">
                                        <button disabled={ isLoading ? true : false } className="btn w-full btn-lg btn-primary">
                                                {
                                                    !isLoading ? null : (
                                                        <>
                                                            <span className='relative mr-2 inline-block '>
                                                                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                </svg>
                                                            </span> 
                                                        </>
                                                    )
                                                }Create Account</button>
                                    </div>
                                </div> */}

                <div className="mb-5">
                  <label className="inline-flex">
                    <input
                      id="acknowledge"
                      name="acknowledge"
                      type="checkbox"
                      className="w-6 h-6 rounded mr-1"
                      onChange={(e) => {
                        formik.setFieldValue("acknowledge", e.target.checked);
                      }}
                    />
                    <span className="ml-2">
                      Creating an account means you’re okay with our{" "}
                      <Link href="#">
                        <a>Terms of Service</a>
                      </Link>
                      , and{" "}
                      <Link href="#">
                        <a>Privacy Policy</a>
                      </Link>
                      .
                    </span>
                  </label>
                  {
                    <div className="help-block text-red-400 text-xs mt-2">
                      {formik.touched.acknowledge &&
                        formik.errors.acknowledge && (
                          <div>{formik.errors.acknowledge}</div>
                        )}
                    </div>
                  }
                </div>

                {/* <pre>
                                    {JSON.stringify(formik.errors, null, 1)}
                                </pre> */}

                <button
                  type="submit"
                  disabled={isLoading ? true : false}
                  className="btn w-full btn-lg btn-primary"
                >
                  {isLoading ? <Spinner isLoading={isLoading} /> : "Submit"}
                </button>
              </form>

              <div className="container block lg:hidden">
                <div className="flex justify-center">
                  <div className="p-12 md:pr-0 lg:pr-12 sm:text-center mb-10">
                    <span>
                      Already a member?{" "}
                      <Link href="/account/login">
                        <a>Login</a>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <KNModal
        title={modalTitle}
        iconType={modalIconType}
        description={modalDescription}
        body={<KNModalBody schemaErrors={SchemaErrors} />}
        isOpen={isModalOpen}
        setModalOpen={(e) => {
          setModalOpen(e);
        }}
        closeModal={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
};

export default RegisterBody;
